import QrBatchEntity from "../../domain/entities/QrBatchEntity";
import StablishmentDto from "./StablishmentDto";

const fromJSON = (json: any): QrBatchEntity => {
    return new QrBatchEntity({
        id: json['zip_token']?.toString() ?? '',
        // stablishment: StablishmentDto.fromJSON(json['stablishment'] || {}),
        createdAt: json['createdAt'] ? new Date(json['createdAt']) : new Date(),
        availables: json['available'] ?? 0,
        used: json['in_use'] ?? 0,
        disabled: json['inactive'] > 0,
    });
}

const toJson = (qr: QrBatchEntity): any => {
    return {
        id: qr.id,
        // stablishment: StablishmentDto.toJson(qr.stablishment),
        createdAt: qr.createdAt.toISOString(),
        available: qr.availables,
        in_use: qr.used,
    }
}

export default {
    fromJSON,
    toJson,
}